import { MenuList } from '@mui/material';
import { useSwimlaneRootProps } from '@/components/ui/swimlane/context';
import { StyledContextMenu, useContextMenu } from '@/components/ui/swimlane/context-menu';
import type { TCardId } from '@/components/ui/swimlane/types';
import { parseCardId } from '@/components/ui/swimlane/utils';

import useSLCardContextMenuSlots from './hooks/useSLCardContextMenuSlots';
import { SLCardContextMenuSlot } from './SLCardContextMenuSlot';

export const CardContextMenu = () => {
  const { actions, readOnly, isPublicationMode, isSubItemFeaturesEnabled } = useSwimlaneRootProps();
  const { contextMenu, closeContextMenu } = useContextMenu();
  const { itemID, columnID, rowID } = parseCardId(contextMenu.itemID as TCardId);
  const { open, data, anchorEl } = contextMenu;
  const menuSlotsData = useSLCardContextMenuSlots({
    itemID,
    columnID,
    rowID,
    canEdit: !readOnly,
    isPublicationMode,
    itemCardActions: actions?.itemCardActions,
    isDeletable: !!data?.isDeletable,
    isSubItemFeaturesEnabled,
  });

  return (
    <StyledContextMenu
      open={open && !isPublicationMode}
      anchorEl={anchorEl}
      MenuListProps={{
        'aria-labelledby': 'card-menu',
      }}
      onClose={closeContextMenu}
    >
      <MenuList>
        {menuSlotsData.map((slotData, index) => (
          <SLCardContextMenuSlot
            key={slotData.slot}
            menuSlot={slotData}
            isLast={index === menuSlotsData.length - 1}
            closeContextMenu={closeContextMenu}
          />
        ))}
      </MenuList>
    </StyledContextMenu>
  );
};
